import ProductHero from './ProductHero.jsx';
import BuiltToGrow from './BuiltToGrow.jsx';
import KeyBenefits from './KeyBenefits.jsx';
import IdealFor from './IdealFor.jsx';

/** Alpha ESS SMILE-G3-S5 product page. */
export default function AlphaEssSmileG3S5() {
  return (
    <>
      <ProductHero />
      <BuiltToGrow />
      <KeyBenefits />
      <hr />
      <IdealFor />
    </>
  );
}
